import { render, staticRenderFns } from "./working-quote-info.vue?vue&type=template&id=45fe8a44&scoped=true&"
import script from "./working-quote-info.vue?vue&type=script&lang=js&"
export * from "./working-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./working-quote-info.vue?vue&type=style&index=0&id=45fe8a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe8a44",
  null
  
)

export default component.exports